<ion-content>
  <div class="nav-menu">
    @for (item of menuItems; track item.page) {
    <div class="menu-item-group">
      <a class="menu-item" [href]="item.page === 'start' ? '/' : '/' + item.page" [class.menu-item-active]="item.isActive" [class.menu-item-expandable]="item.children?.length"
        [class.menu-item-expanded]="item.isExpanded" data-automation-id="menu-item" [attr.data-automation-value]="item.page" (click)="handleMenuItemClick($event, item)">
        <div class="menu-item-icon">
          <app-icon [svg]="item.icon" color="#0e4c6b" size="22"></app-icon>
        </div>
        <div class="menu-item-text">{{ item.textKey | translate }}</div>
        @if (item.children?.length) {
        <div class="menu-item-expand-indicator" (click)="handleExpandIconClick($event, item)">
          <span class="menu-item-expand-chevron"></span>
        </div>
        }
      </a>

      @if (item.isExpanded && item.children?.length) {
      <div class="submenu">
        @for (child of item.children; track child.page) {
        <a class="submenu-item" [href]="'/' + child.page" [class.submenu-item-active]="child.isActive" (click)="handleMenuItemClick($event, child)">
          <div class="submenu-item-text">{{ child.textKey | translate }}</div>
        </a>
        }
      </div>
      }
    </div>
    }
  </div>
</ion-content>
